import { tabularNums } from '@medcom/shared-ui/styles/globalCss.ts';
import type React from 'react';
import { currency } from '../utils/currency';

// Prices are quantities compared across rows/summaries — render with tabular-nums (Inter, not
// mono) so the digits align. See .claude/rules/numeric-typography.md.
export const Price: React.FC<{ value: number | null | undefined; fallback?: string }> = ({ value, fallback }) => (
  <span className={tabularNums}>{currency(value, fallback)}</span>
);
